import RightMenu from './RightMenu';

export default RightMenu;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/RightMenu/index.js